import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API, useAuth } from "@/auth";

export default function Feed() {
 const { user } = useAuth();
 const [rows, setRows] = useState([]);
 const [voting, setVoting] = useState(null);

 const load = () => axios.get(`${API}/feed/battles`).then(r => setRows(r.data));
 useEffect(() => { load(); }, []);

 const vote = async (id, side) => {
 if (!user) { window.location.href = "/login"; return; }
 setVoting(id + side);
 try { await axios.post(`${API}/feed/battles/${id}/vote`, { side }); await load(); }
 catch (e) { alert(e.response?.data?.detail || "Vote failed"); }
 finally { setVoting(null); }
 };

 return (
 <div className="max-w-7xl mx-auto px-6 md:px-10 py-12">
 <div className="font-mono text-xs tracking-[0.4em] text-yt-red mb-2"> THE CYPHER</div>
 <h1 className="font-display text-6xl md:text-7xl tracking-tight mb-3">BATTLE FEED</h1>
 <p className="text-yt-muted max-w-2xl mb-10">Watch the freshest battles. Vote who took it. Top voted bars climb the monthly tournament.</p>

 {rows.length === 0 && (
 <div className="bg-yt-surface border border-yt-border p-12 text-center">
 <div className="font-display text-3xl text-yt-muted">QUIET NIGHT IN THE CYPHER</div>
 <div className="text-sm text-yt-muted mt-2">Complete a battle and the feed lights up.</div>
 </div>
 )}

 <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
 {rows.map(b => {
 const totalVotes = (b.votes_user || 0) + (b.votes_opponent || 0);
 const userPct = totalVotes ? Math.round((b.votes_user || 0) * 100 / totalVotes) : 50;
 return (
 <div key={b.id} className="bg-yt-surface border border-yt-border overflow-hidden">
 <div className="aspect-[16/9] relative bg-black">
 <img src={b.arena_image} alt={b.arena_name} className="absolute inset-0 w-full h-full object-cover opacity-70" />
 <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/60" />
 <div className="absolute inset-0 grid grid-cols-3 items-end p-3">
 <Side name={b.rapper_name} img={b.rapper_portrait} score={b.score_user} side="left" />
 <div className="text-center pb-2">
 <div className="font-mono text-[9px] tracking-widest text-white/70">{b.arena_name?.toUpperCase()}</div>
 <div className="font-display text-2xl">VS</div>
 </div>
 <Side name={b.opponent_name} img={b.opponent_portrait} score={b.score_opponent} side="right" />
 </div>
 <div className="absolute top-2 right-2 bg-black/80 border border-yt-border px-2 py-0.5 font-mono text-[9px] tracking-widest">
 WINNER: <span className={b.winner === "user" ? "text-yt-judge" : b.winner === "draw" ? "text-yt-yellow" : "text-yt-red"}>{(b.winner || "draw").toUpperCase()}</span>
 </div>
 </div>
 <div className="p-4">
 <div className="font-mono text-[10px] tracking-widest text-yt-muted mb-2">CROWD VOTE</div>
 <div className="h-3 bg-black flex overflow-hidden">
 <div className="bg-yt-judge" style={{ width: `${userPct}%` }} />
 <div className="bg-yt-red flex-1" />
 </div>
 <div className="grid grid-cols-2 gap-2 mt-3">
 <button data-testid={`vote-user-${b.id}`} disabled={voting !== null}
 onClick={() => vote(b.id, "user")}
 className="border border-yt-judge text-yt-judge font-mono text-xs tracking-widest py-2 hover:bg-yt-judge hover:text-black transition-colors disabled:opacity-40">
 {b.rapper_name?.toUpperCase()} ({b.votes_user || 0})
 </button>
 <button data-testid={`vote-opponent-${b.id}`} disabled={voting !== null}
 onClick={() => vote(b.id, "opponent")}
 className="border border-yt-red text-yt-red font-mono text-xs tracking-widest py-2 hover:bg-yt-red hover:text-white transition-colors disabled:opacity-40">
 {b.opponent_name?.toUpperCase()} ({b.votes_opponent || 0})
 </button>
 </div>
 </div>
 </div>
 );
 })}
 </div>
 </div>
 );
}

function Side({ name, img, score, side }) {
 return (
 <div className={`flex flex-col ${side === "right" ? "items-end" : ""}`}>
 <div className="w-16 h-16 border-2 border-white/40 overflow-hidden bg-black">
 {img ? <img src={img} alt={name} className={`w-full h-full object-cover ${side === "right" ? "scale-x-[-1]" : ""}`} /> :
 <div className="w-full h-full flex items-center justify-center bg-yt-surface font-display text-lg text-yt-yellow">{(name || "??").slice(0, 2).toUpperCase()}</div>}
 </div>
 <div className={`mt-1 ${side === "right" ? "text-right" : ""}`}>
 <div className="font-display text-base tracking-tight truncate max-w-[120px]">{name}</div>
 <div className="font-display text-xl text-yt-yellow leading-none">{score}</div>
 </div>
 </div>
 );
}
